
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Toasted from 'vue-toasted';
import { WindowType } from "../../../util";
import OrganigramModal from "../../organigramModal/organigramModal.controller";
import { KanbanState } from "../kanban.model";

Vue.use(Toasted, { duration: 2000 });

declare var window: WindowType;

@Component({
  name: 'TimeTrackingSite',
  components: {
    OrganigramModal: require('../../organigramModal/organigramModal.vue.html').default,
  },
})
export default class TimeTrackingSite extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  async mounted(): Promise<void> {
    await this.reloadAll();
  }

  async reloadAll(): Promise<void> {
    await (this.$refs.organigramModal as OrganigramModal).reloadAll();
  }

  private async saveSettings(): Promise<void> {
    await this.state.settingsAPI.update("KanbanSettings", false, false, JSON.stringify(this.state.settings));
  }

  //events
  onAccountSelected(): void {
    this.reloadAll();
  }

  private async onAlwaysShowMyBoardsChanged(): Promise<void> {
    await this.saveSettings();

    //TODO this is an ugly hack to trigger a refresh of the ui due to the layout variable change that should be triggered automatically by vue but isn't
    let x = this.state.settings;
    this.state.settings = null;
    this.state.settings = x;

    await this.reloadAll();
  }

  //getter
  get baseurl(): string {
    return window.application.baseUrl;
  }

  get userid(): string | undefined {
    return window.application.kanban.user?.id;
  }

  get username(): string | undefined {
    return window.application.kanban.user?.userName;
  }

  get alwaysShowMyBoards(): boolean {
    return this.state.settings!.alwaysShowMyBoards;
  }

  set alwaysShowMyBoards(val: boolean) {
    this.state.settings!.alwaysShowMyBoards = val;
    this.onAlwaysShowMyBoardsChanged();
  }

  get isFireProtection(): boolean {
    return window.application.permissions.misc.fireProtection;
  }
}

